import axios from "../API/axios";

const langParam = (language) => (language === "en" ? "" : language || "");

export const isNumericId = (value) => {
  if (value == null || value === "") return false;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 && String(value) === String(n);
};

export const mapIndustryOption = (item) => ({
  value: item.fitid ?? item.fitId ?? item.Fitid,
  label: item.name,
});

export const mapDesignationOption = (item) => ({
  value: item.dsgntnId ?? item.DsgntnId,
  label: item.name,
  fitid: item.fitid ?? item.fitId,
  isVerified: item.isVerified,
  isGeneral: item.isGeneral,
});

export const mapSkillOption = (item) => ({
  value: item.skllId ?? item.SkllId,
  label: item.name ?? item.skillName,
  fitid: item.fitid ?? item.fitId,
  isVerified: item.isVerified,
  isGeneral: item.isGeneral,
});

export const designationNameFromOption = (option) =>
  (option?.label || (typeof option?.value === "string" ? option.value : "") || "").trim();

export const splitSkillPayload = (selected) => {
  const skillIds = [];
  const skillNames = [];
  (Array.isArray(selected) ? selected : selected ? [selected] : []).forEach((item) => {
    if (!item) return;
    if (isNumericId(item.value)) {
      skillIds.push(Number(item.value));
    } else if (item.label) {
      skillNames.push(String(item.label).trim());
    }
  });
  return { skillIds, skillNames };
};

const unwrapDdl = (response) => {
  const payload = response?.data?.responseData || response?.data || {};
  const rows = payload.data || payload.Data || [];
  const paging = payload.paging || payload.Paging || response?.data?.paging || {};
  return { rows: Array.isArray(rows) ? rows : [], paging };
};

export const fetchIndustries = async (language) => {
  const response = await axios.get(
    `Master/GetFirmIndustryTypeDDL?LangKey=${langParam(language)}`
  );
  const rows = response?.data?.responseData || [];
  return (Array.isArray(rows) ? rows : []).map(mapIndustryOption);
};

export const fetchDesignations = async ({
  fitid,
  search = "",
  pageNumber = 1,
  pageSize = 100,
  language,
}) => {
  if (!(fitid > 0)) {
    return { options: [], totalPages: 0 };
  }
  const response = await axios.get(
    `Master/GetDesignationDDL?DeviceType=Web&search=${encodeURIComponent(
      search || ""
    )}&Fitid=${fitid}&pageNumber=${pageNumber}&pageSize=${pageSize}&LangKey=${langParam(
      language
    )}`
  );
  const { rows, paging } = unwrapDdl(response);
  return {
    options: rows.map(mapDesignationOption),
    totalPages: paging.totalPages || paging.TotalPages || 0,
  };
};

export const fetchSkillsByIndustry = async ({
  fitid,
  search = "",
  pageNumber = 1,
  pageSize = 100,
  language,
}) => {
  const hasIndustry = fitid > 0;
  const response = await axios.get(
    hasIndustry
      ? `Master/GetSkillsByIndustryDDL?DeviceType=Web&search=${encodeURIComponent(
          search || ""
        )}&Fitid=${fitid}&pageNumber=${pageNumber}&pageSize=${pageSize}&LangKey=${langParam(
          language
        )}`
      : `Master/GetSkillsDDL?DeviceType=Web&search=${encodeURIComponent(
          search || ""
        )}&pageNumber=${pageNumber}&pageSize=${pageSize}&LangKey=${langParam(
          language
        )}`
  );
  const { rows, paging } = unwrapDdl(response);
  return {
    options: rows.map(mapSkillOption),
    totalPages: paging.totalPages || paging.TotalPages || 0,
  };
};

export const quickAddDesignation = async ({
  name,
  fitid,
  sessionId,
  language,
}) => {
  const trimmed = (name || "").trim();
  if (!trimmed || !(fitid > 0)) {
    return { label: trimmed, value: trimmed };
  }
  try {
    const response = await axios.post("Master/QuickAddDesignation", {
      deviceType: "Web",
      sessionId,
      langKey: langParam(language),
      fitid,
      name: trimmed,
    });
    const row = response?.data?.responseData || {};
    const id = row.dsgntnId ?? row.DsgntnId;
    return {
      value: id || trimmed,
      label: row.name || trimmed,
      fitid: row.fitid ?? fitid,
      isVerified: row.isVerified === true,
    };
  } catch {
    return { label: trimmed, value: trimmed };
  }
};

export const quickAddSkill = async ({ name, fitid, sessionId, language }) => {
  const trimmed = (name || "").trim();
  if (!trimmed || !(fitid > 0)) {
    return { label: trimmed, value: trimmed };
  }
  try {
    const response = await axios.post("Master/QuickAddSkill", {
      deviceType: "Web",
      sessionId,
      langKey: langParam(language),
      fitid,
      name: trimmed,
    });
    const row = response?.data?.responseData || {};
    const id = row.skllId ?? row.SkllId;
    return {
      value: id || trimmed,
      label: row.name || trimmed,
      fitid: row.fitid ?? fitid,
      isVerified: row.isVerified === true,
    };
  } catch {
    return { label: trimmed, value: trimmed };
  }
};

export const mapCompanyOption = (item) => ({
  value: item.compUid,
  label: item.compName,
  industryId: item.industryId ?? item.IndustryId ?? 0,
  industryName: item.industryName || item.IndustryName || "",
});

export const industryOptionFromCompany = (company, industryList = []) => {
  const id = company?.industryId;
  if (!(id > 0)) return null;
  return (
    industryList.find((opt) => String(opt.value) === String(id)) || {
      value: id,
      label: company.industryName || "Company industry",
    }
  );
};

export const mapJobSkills = (jobData, skillNames) => {
  const rows = jobData?.jobSkills || jobData?.JobSkills || [];
  if (Array.isArray(rows) && rows.length > 0) {
    return rows.map((item) => ({
      value: item.skllId ?? item.SkllId,
      label: item.name || item.Name,
      fitid: item.fitid ?? item.Fitid,
    }));
  }
  return (Array.isArray(skillNames) ? skillNames : []).map((name) => ({
    value: name,
    label: name,
  }));
};
